import BaseButtonNeutral from "./BaseButtonNeutral.vue";
import BaseNavLink from "./BaseNavLink.vue";

export default {
    'base-button-neutral': BaseButtonNeutral,
    'base-nav-link': BaseNavLink,
};